var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCoupons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.948,
    height: 100.931,
    viewBox: "0 0 139.948 100.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0.472 0.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(0 20.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M99.061,364.968a.767.767,0,0,1-.745-.6l-4.372-20.188a.763.763,0,0,1,.585-.908,9.92,9.92,0,0,0-2.081-19.615,10.1,10.1,0,0,0-1.714.148c-.135.023-.271.05-.4.079a.763.763,0,0,1-.908-.584l-4.372-20.188a.765.765,0,0,1,.584-.908l28.57-6.187a.774.774,0,0,1,.161-.017.763.763,0,0,1,.746.6l13.265,61.256a.758.758,0,0,1-.1.575.769.769,0,0,1-.48.333l-28.57,6.187A.77.77,0,0,1,99.061,364.968Zm-6.606-42.84a11.449,11.449,0,0,1,3.658,22.288l-.517.175L99.647,363.3l27.078-5.864L113.783,297.67l-27.078,5.864,4.051,18.708.543-.055C91.683,322.148,92.072,322.128,92.456,322.128Z",
    transform: "translate(-85.034 -295.999)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 2.509,
    height: 2.565,
    transform: "translate(8.12 32.888) rotate(-12.217)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 2.538,
    height: 2.518,
    transform: "translate(18.039 78.661) rotate(-12.221)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 2.509,
    height: 2.565,
    transform: "translate(117.835 9.129) rotate(-12.217)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 2.538,
    height: 2.518,
    transform: "translate(127.753 54.902) rotate(-12.219)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 2.564,
    height: 2.537,
    transform: "translate(54.402 46.823) rotate(-12.217)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 2.549,
    height: 2.523,
    transform: "translate(49.447 23.95) rotate(-12.219)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 2.569,
    height: 2.496,
    transform: "translate(51.084 31.575) rotate(-12.216)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 2.555,
    height: 2.516,
    transform: "translate(57.715 62.094) rotate(-12.216)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2.541,
    height: 2.517,
    transform: "translate(59.379 69.698) rotate(-12.22)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 2.544,
    height: 2.502,
    transform: "translate(52.761 39.195) rotate(-12.22)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M269.011,407.817c-.166-.736-.325-1.474-.492-2.251l-.05-.23,2.618-.567.063.281c.166.737.323,1.433.433,2.126a.56.56,0,0,1-.064.118c-.7.192-1.407.339-2.155.494l-.34.071A.351.351,0,0,1,269.011,407.817Z",
    transform: "translate(-212.461 -350.843)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M344.394,336.914a1.03,1.03,0,0,1-.573-.174l-.03-.02a1.041,1.041,0,0,1-.3-1.423l21.94-34.069a1.035,1.035,0,0,1,1.446-.3l.029.019a1.041,1.041,0,0,1,.3,1.423l-21.94,34.069A1.033,1.033,0,0,1,344.394,336.914Z",
    transform: "translate(-264.466 -278.585)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M412.158,380a7.164,7.164,0,0,1-7.064-5.731,7.28,7.28,0,0,1,5.609-8.463,7.177,7.177,0,0,1,7.38,11.042,7.077,7.077,0,0,1-4.569,3.021A7.167,7.167,0,0,1,412.158,380Zm-.034-11.664a4.5,4.5,0,1,0,.006,8.994h0a4.588,4.588,0,0,0,1.023-.116,4.437,4.437,0,0,0,3.363-5.319A4.53,4.53,0,0,0,412.125,368.335Z",
    transform: "translate(-307.29 -323.682)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M321.029,321.382a7.171,7.171,0,1,1-.023-14.343,7.171,7.171,0,0,1,.023,14.343Zm-.019-11.666a4.661,4.661,0,0,0-1.054.122,4.445,4.445,0,0,0-3.354,5.335,4.547,4.547,0,0,0,4.421,3.535h0a4.406,4.406,0,0,0,3.722-2.051,4.544,4.544,0,0,0,.634-3.434A4.45,4.45,0,0,0,321.01,309.716Z",
    transform: "translate(-243.966 -282.953)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 2.564,
    height: 2.537,
    transform: "translate(54.402 46.823) rotate(-12.217)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 2.549,
    height: 2.523,
    transform: "translate(49.447 23.95) rotate(-12.219)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 2.569,
    height: 2.496,
    transform: "translate(51.084 31.575) rotate(-12.216)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 2.555,
    height: 2.516,
    transform: "translate(57.715 62.094) rotate(-12.216)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 2.541,
    height: 2.517,
    transform: "translate(59.379 69.698) rotate(-12.22)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 2.544,
    height: 2.502,
    transform: "translate(52.761 39.195) rotate(-12.22)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M269.011,407.817c-.166-.736-.325-1.474-.492-2.251l-.05-.23,2.618-.567.063.281c.166.737.323,1.433.433,2.126a.56.56,0,0,1-.064.118c-.7.192-1.407.339-2.155.494l-.34.071A.351.351,0,0,1,269.011,407.817Z",
    transform: "translate(-212.461 -350.843)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M239.418,308.557a.767.767,0,0,1-.745-.6L225.408,246.7a.758.758,0,0,1,.1-.575.768.768,0,0,1,.48-.333l81.372-17.621a.78.78,0,0,1,.165-.018.766.766,0,0,1,.743.6l4.372,20.188a.764.764,0,0,1-.584.907,9.921,9.921,0,0,0,2.081,19.616,10.028,10.028,0,0,0,2.118-.228.784.784,0,0,1,.162-.017.758.758,0,0,1,.413.122.767.767,0,0,1,.333.48l4.371,20.188a.764.764,0,0,1-.585.908L239.58,308.54A.767.767,0,0,1,239.418,308.557Zm-12.356-61.434L240,306.886l79.88-17.3-4.051-18.707-.543.055a11.538,11.538,0,0,1-1.156.059,11.449,11.449,0,0,1-3.657-22.288l.517-.175-4.051-18.707Z",
    transform: "translate(-182.535 -228.153)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M271.336,488.987",
    transform: "translate(-214.452 -409.346)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M271.336,488.987",
    transform: "translate(-214.452 -409.346)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M257.763,540.03a.768.768,0,0,1-.731-.545l-1.606-5.377a.763.763,0,1,1,1.463-.437l1.605,5.377a.764.764,0,0,1-.732.982Z",
    transform: "translate(-203.378 -440.007)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M272,519.843a.754.754,0,0,1-.494-.182l-3.493-2.971a.763.763,0,0,1,.495-1.345.756.756,0,0,1,.495.182L272.5,518.5a.763.763,0,0,1-.5,1.345Z",
    transform: "translate(-211.957 -427.656)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M231.6,533.518a.794.794,0,0,1-.107-.008.764.764,0,0,1-.651-.86l.564-4.09a.767.767,0,0,1,.757-.659.776.776,0,0,1,.105.007.764.764,0,0,1,.65.86l-.564,4.09A.766.766,0,0,1,231.6,533.518Z",
    transform: "translate(-186.32 -436.379)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M189.34,239.847a.763.763,0,0,1-.739-.576l-1.383-5.439a.763.763,0,0,1,.552-.928.762.762,0,0,1,.928.552l1.383,5.439a.764.764,0,0,1-.552.928A.776.776,0,0,1,189.34,239.847Z",
    transform: "translate(-156.002 -231.437)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M212.214,251.258a.764.764,0,0,1-.723-1.008l1.472-4.344a.763.763,0,1,1,1.446.49l-1.472,4.344A.763.763,0,0,1,212.214,251.258Z",
    transform: "translate(-172.851 -240.124)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M169.807,261.04a.761.761,0,0,1-.6-.285l-2.584-3.22a.763.763,0,0,1,1.191-.956l2.584,3.22a.763.763,0,0,1-.594,1.241Z",
    transform: "translate(-141.597 -247.701)",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.908
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoupons);
export default __webpack_public_path__ + "static/media/no-coupons.d81c0440e931c6b6886b3736ba43d4bc.svg";
export { ForwardRef as ReactComponent };